// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1AkLg","bigColWidth":"Table_bigColWidth__2Z91z","biggerColWidth":"Table_biggerColWidth__NY1AX","row":"Table_row__2Jkqa","col":"Table_col__2gAvC"};